import apiConfig from './config'

export default {
  ...apiConfig,
  index: '/dashboard/permissions/',
  availableActions: '/dashboard/permissions/available-actions/',
}
